import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { SettingsProvider } from './context/SettingsContext.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';

import Home from './pages/Home.jsx';
import ServicesPage from './pages/ServicesPage.jsx';
import PortfolioPage from './pages/PortfolioPage.jsx';
import TestimonialPage from './pages/TestimonialPage.jsx';
import KontakPage from './pages/KontakPage.jsx';
import JadwalPage from './pages/JadwalPage.jsx';
import ArtikelPage from './pages/ArtikelPage.jsx';
import NotFound from './pages/NotFound.jsx';

import AdminLogin from './admin/pages/AdminLogin.jsx';
import ProtectedRoute from './admin/components/ProtectedRoute.jsx';
import AdminDashboard from './admin/pages/AdminDashboard.jsx';
import CarouselList from './admin/pages/CarouselList.jsx';
import CarouselForm from './admin/pages/CarouselForm.jsx';
import LayananList from './admin/pages/LayananList.jsx';
import LayananForm from './admin/pages/LayananForm.jsx';
import PortfolioList from './admin/pages/PortfolioList.jsx';
import PortfolioForm from './admin/pages/PortfolioForm.jsx';
import TestimonialList from './admin/pages/TestimonialList.jsx';
import TestimonialForm from './admin/pages/TestimonialForm.jsx';
import KontakList from './admin/pages/KontakList.jsx';
import BookingList from './admin/pages/BookingList.jsx';
import SettingsPage from './admin/pages/SettingsPage.jsx';

export default function App() {
  return (
    <ThemeProvider>
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Publik */}
              <Route path="/" element={<Home />} />
              <Route path="/layanan" element={<ServicesPage />} />
              <Route path="/portofolio" element={<PortfolioPage />} />
              <Route path="/artikel/:id" element={<ArtikelPage />} />
              <Route path="/testimoni" element={<TestimonialPage />} />
              <Route path="/jadwal" element={<JadwalPage />} />
              <Route path="/kontak" element={<KontakPage />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/carousel" element={<ProtectedRoute><CarouselList /></ProtectedRoute>} />
              <Route path="/admin/carousel/new" element={<ProtectedRoute><CarouselForm /></ProtectedRoute>} />
              <Route path="/admin/carousel/:id/edit" element={<ProtectedRoute><CarouselForm /></ProtectedRoute>} />
              <Route path="/admin/layanan" element={<ProtectedRoute><LayananList /></ProtectedRoute>} />
              <Route path="/admin/layanan/new" element={<ProtectedRoute><LayananForm /></ProtectedRoute>} />
              <Route path="/admin/layanan/:id/edit" element={<ProtectedRoute><LayananForm /></ProtectedRoute>} />
              <Route path="/admin/portfolio" element={<ProtectedRoute><PortfolioList /></ProtectedRoute>} />
              <Route path="/admin/portfolio/new" element={<ProtectedRoute><PortfolioForm /></ProtectedRoute>} />
              <Route path="/admin/portfolio/:id/edit" element={<ProtectedRoute><PortfolioForm /></ProtectedRoute>} />
              <Route path="/admin/testimonial" element={<ProtectedRoute><TestimonialList /></ProtectedRoute>} />
              <Route path="/admin/testimonial/new" element={<ProtectedRoute><TestimonialForm /></ProtectedRoute>} />
              <Route path="/admin/testimonial/:id/edit" element={<ProtectedRoute><TestimonialForm /></ProtectedRoute>} />
              <Route path="/admin/kontak" element={<ProtectedRoute><KontakList /></ProtectedRoute>} />
              <Route path="/admin/booking" element={<ProtectedRoute><BookingList /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </ThemeProvider>
  );
}